<ng-template #cpuInput>
  <mat-form-field>
    <mat-label>{{ formData.label }}</mat-label>
    <mat-select
      (focus)="onFocus()"
      (focusout)="onBlur()"
      [(value)]="value"
      [formControl]="formGroup.controls[formName]"
      [required]="formData.isRequired">
      @for (item of items; track $index) {
        @if (item.value != '-') {
          <mat-option
            [class]="item.invalid?'invalid':''"
            [disabled]="item.disabled"
            [value]="item.value">
            {{ item.label }}
          </mat-option>
        } @if (item.value == '-') {
          <mat-option disabled>
            @if (item.label != null) {
              {{ item.label }}
            }
            <mat-divider [inset]="false"></mat-divider>
          </mat-option>
        }
      }
    </mat-select>
    <app-error [formGroup]="formGroup" [formName]="formName"></app-error>
  </mat-form-field>
</ng-template>

<app-base [childContext]="ctx" [componentsTemplate]="cpuInput"></app-base>
